module.exports = __webpack_public_path__ + "img/141.f7aeef6c.jpg";